import SearchWithRecommendations from 'components/SearchWithRecommendations'
import { useTranslate } from 'lib/tolgee'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

import type { TThemeListTab } from './theme-list-tab.types'
import { GlobalTopicsTableView } from '../global-topics-table'
import './theme-list-tab.styles.scss'

export const ThemeListTabView = ({
  data,
  error,
  handleSetOrder,
  isLoading,
  order,
  refetch,
  totalCount,
  search,
  handleTypeSearch,
  handleSelectSearchOption,
  handleSubmitSearch,
}: TThemeListTab) => {
  const t = useTranslate()

  return (
    <div className="ThemeListTab">
      <div className="ThemeListTab-search">
        <SearchWithRecommendations
          key={search}
          defaultSearchText={search}
          placeholder={t(TOLGEE_GLOBALS.search)}
          onType={handleTypeSearch}
          handleOnChange={handleSelectSearchOption}
          onSubmit={handleSubmitSearch}
          isViewerBlocked={false}
          isCustomOption
        />
      </div>
      <GlobalTopicsTableView
        data={data}
        error={error}
        handleSetOrder={handleSetOrder}
        hasMore={false}
        isFetchingMore={false}
        isLoading={isLoading}
        refetch={refetch}
        totalCount={totalCount}
        order={order}
        sentryRef={null}
        isZaiReportColumnVisible={false}
        isRelevanceRetryVisible={false}
      />
    </div>
  )
}
